import { BOOKING_SCOPE_CONTENT_CLASS_NAME } from "../constants";

export const getContentTarget = () => {
    // The booking engine is rendered on the customers website. In that scenario, we don't want to use the body as target.
    const target = document.querySelector(`.${BOOKING_SCOPE_CONTENT_CLASS_NAME}`) || document.body;
    return target as HTMLElement;
};
